import { PolicyType } from '../../types/policy.types';
import styles from './TypeSelection.module.css';
import {
	DescriptionOutlined,
	LockOutlined,
	StorageOutlined,
	ShareOutlined,
	CampaignOutlined,
} from '@mui/icons-material';

interface TypeSelectionProps {
	onSelect: (type: PolicyType) => void;
}

const policyTypes = [
	{
		type: 'terms_of_use' as PolicyType,
		icon: <DescriptionOutlined />,
		title: 'Termos de Uso',
		description: 'Termos e condições de uso da plataforma',
	},
	{
		type: 'privacy_policy' as PolicyType,
		icon: <LockOutlined />,
		title: 'Política de Privacidade',
		description: 'Como os dados dos usuários são tratados',
	},
	{
		type: 'data_processing' as PolicyType,
		icon: <StorageOutlined />,
		title: 'Consentimento de Processamento',
		description: 'Consentimento do usuário para tratamento de dados',
	},
	{
		type: 'third_party_sharing' as PolicyType,
		icon: <ShareOutlined />,
		title: 'Consentimento com Terceiros',
		description: 'Consentimento para compartilhamentos em integrações do Practium',
	},
	{
		type: 'marketing' as PolicyType,
		icon: <CampaignOutlined />,
		title: 'Consentimento para Comunicações de Marketing',
		description: 'Autorização do usuário para receber comunicações de marketing',
	},
];

export const TypeSelection = ({ onSelect }: TypeSelectionProps) => {
	return (
		<div className={styles.typeSelection}>
			<h2 className={styles.typeTitle}>Selecione o tipo de política</h2>
			<p className={styles.typeDescription}>
				Escolha o tipo de política que deseja criar. Apenas uma política de cada tipo pode estar
				ativa por vez.
			</p>
			<div className={styles.typeButtons}>
				{policyTypes.map((item) => (
					<button key={item.type} className={styles.typeButton} onClick={() => onSelect(item.type)}>
						<div className={styles.typeButtonIcon}>{item.icon}</div>
						<div className={styles.typeButtonContent}>
							<div className={styles.typeButtonTitle}>{item.title}</div>
							<div className={styles.typeButtonDesc}>{item.description}</div>
						</div>
					</button>
				))}
			</div>
		</div>
	);
};
